import * as React from 'react'
import ListCell from '@doordash/component-list-cell'
import { Colors, Text } from '@doordash/design-language'
import { clone, setWith } from 'lodash'
import { OnboardingComponentProps } from '.'

export const ListComponent: React.FC<OnboardingComponentProps> = ({
  onSubmitStep,
  apiPath,
  templateResponseData,
  ...props
}) => {
  const listData = props.data_map
  const onClickHandler = doc => {
    const updatedTemplateResponseData = setWith(
      clone(templateResponseData),
      apiPath,
      doc,
      clone
    )
    onSubmitStep(updatedTemplateResponseData)
  }

  return (
    <div>
      {listData.map(item => {
        return (
          <ListCell
            key={item.value}
            insetSize={ListCell.InsetSizes.Small}
            subtext={
              <Text color={Colors.SystemBlack} styles={Text.Styles.Label1}>
                {item.name}
              </Text>
            }
            iconEnd={{
              type: ListCell.IconTypes.ChevronRight,
            }}
            onClick={() => onClickHandler(item.value)}
          />
        )
      })}
    </div>
  )
}

export default ListComponent
